<template>
  <v-row >
    <v-col cols-12 md-6 >

      <div class="my-2">  
        <div v-for="col in meta.columns" :key="col">
          <base-geo-cell v-if = "col.fieldname === 'species'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
        </div>
      </div>
      <v-sheet class="d-flex flex-wrap mb-2">
        <v-sheet style="min-width: 300px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'detname2'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div> 
        </v-sheet>

        <v-sheet style="min-width: 300px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'detdate'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div>
        </v-sheet>
      </v-sheet>

      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'comment_sps'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>

      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'picturesp'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>

      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.description.includes('molecularbiology')" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>



    </v-col>
  <!--end of first column-->
    <v-col  cols-12 md-6 style="min-width: 300px; max-width: 350px">
    <v-sheet style="min-width: 300px; max-width: 100%;" class="my-1">
      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'colspnum'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>
    </v-sheet>

    <v-sheet style="min-width: 300px; max-width: 100%;" class="my-1 d-flex flex-wrap">
      <span>LID:</span>&nbsp; 
      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'link_to_specimen'" v-bind="{mode:'view', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>
    </v-sheet>
  <!-- extradata: -->
  <!-- <v-btn
    @click="dialogedecology=!dialogedecology" 
    class="my-1"
    variant="flat"
    color="regular"
    >Extradata
  </v-btn> -->
    </v-col>
  </v-row>
<!--dialogs:-->
  <v-dialog fullscreen v-model="dialogedecology">
  <v-card class="rounded-0">
    <v-sheet class="d-flex flex-wrap ma-2">
      <div v-for="col in meta.columns" :key="col">
        <v-sheet class="mr-1" min-width="200">
          <base-geo-cell v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
        </v-sheet>
      </div>
    </v-sheet>
    <div class="d-flex justify-space-between">
      <v-btn 
      class="my-1 ml-2"
      variant="outlined"
      color="regular"
      @click="dialogedecology = !dialogedecology"
      size="x-large"
      >Exit
      </v-btn>
      <v-btn 
      class="my-1 ma-2"
      variant="flat"
      color="attention"
      @click="dialogedecology = !dialogedecology"
      size="x-large"
      >Submit
      </v-btn>
    </div>
  </v-card>
</v-dialog>

</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'StandardMssSpeciesInDetailsFormT',
    components: {

},

data(){ 
    return {
      dialogedecology: false,

    }
},
props:['meta', 'curentRow', 'modelValue'],
emits: ['update:modelValue'],
methods: {

},

  mounted(){

  },

})
</script>